module.exports = __webpack_public_path__ + "img/money-bag.27eea29d.svg";